module.exports = __webpack_public_path__ + "img/about_logo_31.eccc03e5.png";